SystemJS.config({
    //defaultJSExtensions: true,
    baseURL: '/scripts',
    paths: {
        "npm:*": "../../../node_modules/*"
    },
    // map tells the System loader where to look for things
    map: {
        "angular": "bower_components/angular.js",
        'ui-bootstrap-custom': 'components/ui-bootstrap-custom-2.5.0.js'
    },
    meta: {
        'angular': {
            format: 'global',
        }
    }
});
